import React from "react";
import { cn } from "../../lib/utils";
import type { DashboardShellProps } from "./types";

/**
 * DashboardShell is the primary application frame for the dashboard.
 * It provides a top-level layout with persistent left navigation,
 * an optional top bar, and a single main content area.
 */
export function DashboardShell({
  sidebar,
  topBar,
  bottomBar,
  children,
  className,
  contentClassName,
  contentScrollMode = "shell",
}: DashboardShellProps) {
  return (
    <div
      className={cn(
        "flex h-[100dvh] min-h-0 w-full overflow-hidden bg-background text-foreground",
        className
      )}
    >
      <aside className="flex-shrink-0 border-r border-border relative z-20 bg-card shadow-sm transition-[width] duration-200 ease-out">
        {sidebar}
      </aside>

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden relative z-10">
        {topBar && (
          <header className="flex-shrink-0 border-b border-border relative z-30 bg-card shadow-sm">
            {topBar}
          </header>
        )}

        <main
          className={cn(
            "min-h-0 min-w-0 flex-1 bg-background relative z-0",
            contentScrollMode === "shell" ? "overflow-auto" : "overflow-hidden",
            contentClassName
          )}
        >
          <div className={cn("relative h-full w-full", bottomBar && "pb-16 md:pb-0")}>
            {children}
          </div>
        </main>
      </div>

      {bottomBar && (
        <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden">
          {bottomBar}
        </div>
      )}
    </div>
  );
}
